export default [
  {
    id: 1,
    attachList: [{ fileUrl: require("../../assets/images/equipments/1.jpg") }],
    name: "CNC",
    introduce: "AWEA P3021",
  },
  {
    id: 2,
    attachList: [{ fileUrl: require("../../assets/images/equipments/2.jpg") }],
    name: " FITTING MACHINE",
    introduce: "SANKI SDP3020",
  },
  {
    id: 3,
    attachList: [{ fileUrl: require("../../assets/images/equipments/3.jpg") }],
    name: "CNC",
    introduce: "FIVE AXIS MECOF  ",
  },
  {
    id: 4,
    attachList: [{ fileUrl: require("../../assets/images/equipments/4.jpg") }],
    name: "GUNDRILL",
    introduce: "AUERBACH IA3 TLF",
  },
  {
    id: 5,
    attachList: [{ fileUrl: require("../../assets/images/equipments/5.jpg") }],
    name: "GUNDRILL",
    introduce: "AUERBACH IA5 TLF",
  },
  {
    id: 6,
    attachList: [{ fileUrl: require("../../assets/images/equipments/6.jpg") }],
    name: "LOW SPEED WEDM",
    introduce: "MAKINO",
  },
  {
    id: 7,
    attachList: [{ fileUrl: require("../../assets/images/equipments/7.jpg") }],
    name: "LOW SPEED WEDM",
    introduce: "SODIC",
  },
  {
    id: 8,
    attachList: [{ fileUrl: require("../../assets/images/equipments/8.jpg") }],
    name: "CNC",
    introduce: "TAKUMI H16",
  },
];
